/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import {
  Row,
  Col,
  Select,
  message,
  Checkbox,
  Card,
  Input,
  Button,
  Icon,
  Spin
} from 'antd';
import {
  ssrHandler,
  fetchActiveReportsMetaData,
  fetchEnterpriseByUser,
  fetchFeatureEnvs,
  updateFeatureEnvs,
  dashboardLogin,
  submitFeatureEnvs
} from '../../actions/sessionActions';
import { APIs } from '../../utils/apis';
import axios from 'axios';
import Cookies from 'universal-cookie';

const antIcon = <Icon type="loading" style={{ fontSize: 24 }} spin />;

const cookies = new Cookies();

const { Option } = Select;

const ButtonGroup = Button.Group;

// const newDashboards = [
//   'b2b',
//   'b2b-staging',
//   'dashboard-v2',
//   'dashboard-v3',
//   'dashboard',
//   'admin',
//   'admin-dev',
//   'dashboard-us',
//   'trackingV2'
// ];
const dashboardTypes = [
  {
    label: 'B2C',
    value: 'b2c'
  },
  {
    label: 'B2C-US',
    value: 'b2c_us'
  },
  { label: 'B2B', value: 'b2b' },
  { label: 'Prism', value: 'prism' },
  { label: 'Returns Plus', value: 'returnsPlus' },
  { label: 'Tracking V2', value: 'trackingV2' }
];
const labels = {
  b2c: 'B2C Dashboard',
  b2c_us: 'B2C-US Dashboard',
  b2b: 'B2B Dashboard',
  prism: 'Prism Dashboard',
  returnsPlus: 'Returns Plus',
  trackingV2: 'Tracking V2 - Builder'
};

// Hardcoded read-only targets for restricted users (Enterprise Login — no feature-env editor)
const RESTRICTED_READONLY_ENVS = [
  {
    label: 'B2C India',
    link: 'https://nnbph3dhvorsg8fue8eav7cu03q1ur6fm.clickpost.in',
    route: '/',
    envKey: 'b2c'
  },
  {
    label: 'B2C US',
    link: 'https://p1axcychc8km8d1e.clickpost.ai',
    route: '/',
    envKey: 'b2c_us'
  },
  {
    label: 'B2B',
    link: 'https://b38qn2ha61uun1vp.clickpost.ai',
    route: '/',
    envKey: 'b2b'
  }
];

export class DashboardLogin extends Component {
  static async fetchData({ dispatch }, match, route) {
    await dispatch(ssrHandler(route.path));
  }
  constructor() {
    super();
    this.state = {
      enterpriseId: undefined,
      users: [],
      user: {},
      userIndex: null,
      isLocalhost: null,
      selectedDashboard: null,
      label: '',
      link: '',
      route: '',
      type: '',
      isUpdate: false,
      showTrackingV2: false,
      /** { type, index } when editing an existing feature env */
      editingFeatureEnv: null
    };
    this.windowObjectReference = null;
  }

  componentDidMount() {
    // Due to sensitivity of the feature, we are not showing the trackingV2 button in the dashboard login page unless the user is logged in with the v2=true flag
    if (window.location.href.includes('v2=true')) {
      this.setState({ showTrackingV2: true });
    }
    // this.props.fetchActiveReportsMetaData('enterprise');
    this.props.fetchEnterpriseByUser();
    this.props.fetchFeatureEnvs();
  }

  handleCheckboxChange = e => {
    const isLocalhost = e.target.checked;
    this.setState({ isLocalhost });
  };

  handleChange = (key, value) => {
    if (key === 'enterpriseId') {
      this.setState({
        [key]: value,
        users: [],
        user: {},
        userIndex: null
      });
      if (value) {
        this.props.dashboardLogin(value).then(res => {
          if (
            (res.result && res.result.length > 0) ||
            (res.meta.status === 200 && res.result.length > 0)
          ) {
            const users = res.result.map(user => {
              user.username = user.name;
              return user;
            });
            this.setState({ users, user: users[0] ?? {} });
          } else {
            message.info(
              'There is some issue with this enterprise, we request you to contact tech team'
            );
          }
        });
      }
    } else if (key === 'userIndex') {
      const { users } = this.state;
      this.setState({ [key]: value, user: users[value] });
    } else if (key === 'selectedDashboard') {
      this.setState({
        [key]: value
      });
      this.handleClick(null, value);
    } else if (
      key === 'label' ||
      key === 'link' ||
      key === 'type' ||
      key === 'route'
    ) {
      this.setState({
        [key]: value
      });
    }
  };

  handleClick = (e, subdomain, route, envKey) => {
    if (e) e.preventDefault();
    const { metadata } = this.props;
    const { isLocalhost } = this.state;
    const obj = this.state.user;
    if (metadata.support) {
      obj.email = 'support@clickpost.in';
    }
    if (!obj.sub_token) {
      const user_id = cookies.get('user_id');
      const requestData = {
        user_id: obj.user_id,
        internal_user_id: user_id
      };

      return axios({
        url: APIs.GENERATE_TOKEN,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: requestData
      })
        .then(response => {
          if (response.data.token) {
            obj.sub_token = response.data.token;
            this.proceedWithLogin(obj, subdomain, route, isLocalhost, envKey);
          } else {
            message.error('Failed to fetch token: ' + response.data.error);
          }
        })
        .catch(() => {
          message.error('Error fetching token. Please try again.');
        });
    } else {
      this.proceedWithLogin(obj, subdomain, route, isLocalhost, envKey);
    }
  };

  proceedWithLogin = (obj, subdomain, route, isLocalhost, envKey) => {
    const internal_user_id = cookies.get('user_id');
    let searchParam = `enterprise_id=${this.state.enterpriseId}&internal_user_id=${internal_user_id}&is_internal_user=true`;
    if (obj?.original_user_id) {
      obj.user_id = obj.original_user_id;
    }
    for (const key in obj) {
      searchParam += `${obj ? '&' : ''}${key}=${obj[key]}`;
    }
    if (envKey === 'returnsPlus') {
      searchParam = `token=${obj.token}&shop_domain=${obj.enterprise_name}.myshopify.com`;
    }
    axios({
      url: `${APIs.APP.ENCRYPT}`,
      method: 'POST',
      data: { input: searchParam }
    }).then(res => {
      if (res?.status === 200) {
        this.setState({
          selectedDashboard: ''
        });
        const encryptedSearchParams = `login?${(subdomain ===
          'https://admin.clickpost.ai' ||
        subdomain === 'https://admin-dev.clickpost.ai' ||
        subdomain === 'trackingV2'
          ? ''
          : `next=${route ? route : '/'}&`) +
          'hash=' +
          res.data}`;

        let url = `${subdomain}/${encryptedSearchParams}`;
        if (subdomain === 'trackingV2') {
          url = `http://subdomain.domain.tld/builder/${encryptedSearchParams}`;
        }
        if (isLocalhost) {
          url =
            envKey === 'returnsPlus'
              ? `http://localhost:3010/${encryptedSearchParams}`
              : `http://localhost:3000/${encryptedSearchParams}`;
        }

        if (
          this.windowObjectReference == null ||
          this.windowObjectReference.closed
        ) {
          this.windowObjectReference = window.open(
            url,
            'Dashboard',
            'noopener'
          ); // as per https://developer.mozilla.org/en-US/docs/web/api/window/open#best_practices
        } else {
          this.windowObjectReference.focus();
        }
      }
    });
  };

  /**
   * Unlocked envs as a flat list for the API (adds + deletes both end up here on Save).
   */
  buildUnlockedEnvironmentsPayload = () => {
    const { environments } = this.props.featureEnvs;
    if (!environments) return [];
    return Object.keys(environments).reduce((acc, key) => {
      const unlocked = (environments[key] || [])
        .filter(env => !env.locked)
        .map(env => ({
          label: env.label,
          link: env.link,
          route: env.route,
          type: key
        }));
      return [...acc, ...unlocked];
    }, []);
  };

  /** Step 2 for both add and delete: push current unlocked list to Firestore. */
  persistFeatureEnvsToApi = () =>
    this.props.submitFeatureEnvs({
      environments: this.buildUnlockedEnvironmentsPayload()
    });

  onUpdate = () => {
    if (this.state.isUpdate) {
      this.persistFeatureEnvsToApi().then(res => {
        const status = res.meta && res.meta.status;
        if (status === 200 || status === 201) {
          message.success(
            (res.meta && res.meta.message) ||
              'Feature environments saved successfully'
          );
          this.setState({
            isUpdate: false,
            editingFeatureEnv: null,
            label: '',
            link: '',
            route: '',
            type: ''
          });
        } else if (res.meta && res.meta.message) {
          message.error(res.meta.message);
        }
      });
    } else {
      this.setState({
        isUpdate: true,
        editingFeatureEnv: null,
        label: '',
        link: '',
        route: '',
        type: ''
      });
    }
  };

  clearFeatureEnvForm = () => {
    this.setState({
      editingFeatureEnv: null,
      label: '',
      link: '',
      route: '',
      type: ''
    });
  };

  /** Step 1 (edit): load row into Developer Section — then Apply, then Save. */
  startEditFeatureEnv = (envType, index) => {
    const env = (this.props.featureEnvs.environments[envType] || [])[index];
    if (!env || env.locked) return;
    this.setState({
      editingFeatureEnv: { type: envType, index },
      label: env.label || '',
      link: env.link || '',
      route: env.route || '',
      type: envType
    });
  };

  /** Step 1 (delete): remove from in-memory list — same pattern as addFeatureEnvs. */
  deleteFeatureEnvFromList = (type, index) => {
    const { environments } = this.props.featureEnvs;
    const list = environments[type] || [];
    const target = list[index];
    if (!target || target.locked) return;
    const next = {
      ...environments,
      [type]: list.filter((_, i) => i !== index)
    };
    this.props.updateFeatureEnvs(next);
    const { editingFeatureEnv } = this.state;
    if (
      editingFeatureEnv &&
      editingFeatureEnv.type === type &&
      editingFeatureEnv.index === index
    ) {
      this.clearFeatureEnvForm();
    } else if (
      editingFeatureEnv &&
      editingFeatureEnv.type === type &&
      index < editingFeatureEnv.index
    ) {
      this.setState({
        editingFeatureEnv: {
          ...editingFeatureEnv,
          index: editingFeatureEnv.index - 1
        }
      });
    }
  };

  onDelete = (e, type, index) => {
    this.deleteFeatureEnvFromList(type, index);
  };

  /**
   * Step 1 (add or edit): update in-memory list — then Save runs persistFeatureEnvsToApi.
   * Edit flow: startEditFeatureEnv → change fields → Apply changes → Save.
   */
  applyFeatureEnvForm = () => {
    const { type, label, link, route, editingFeatureEnv } = this.state;
    if (!type || !label || !link || !route) {
      return message.error('Please fill all the fields');
    }
    const { environments } = this.props.featureEnvs;
    if (!(type in environments)) return;

    if (editingFeatureEnv) {
      const { type: prevType, index } = editingFeatureEnv;
      if (prevType === type) {
        const list = [...(environments[type] || [])];
        const prev = list[index];
        if (!prev || prev.locked) {
          return message.error('Cannot edit this environment');
        }
        list[index] = { ...prev, label, link, route };
        this.props.updateFeatureEnvs({ ...environments, [type]: list });
      } else {
        const oldList = [...(environments[prevType] || [])];
        const [removed] = oldList.splice(index, 1);
        if (!removed || removed.locked) {
          return message.error('Cannot move locked environment');
        }
        const targetList = [
          ...(environments[type] || []),
          { label, link, route }
        ];
        this.props.updateFeatureEnvs({
          ...environments,
          [prevType]: oldList,
          [type]: targetList
        });
      }
      this.clearFeatureEnvForm();
    } else {
      const next = {
        ...environments,
        [type]: [...(environments[type] || []), { label, link, route }]
      };
      this.props.updateFeatureEnvs(next);
      this.setState({ label: '', link: '', type: '', route: '' });
    }
  };

  render() {
    const { metadata, featureEnvs } = this.props;
    const { users } = this.state;
    const { environments } = featureEnvs;
    const userAccessType =
      window.location.hostname !== 'api.clickpost.ai'
        ? 'admin'
        : metadata.userAccessType ?? 'restricted';
    const envKeys = ['b2c', 'b2c_us', 'b2b', 'prism', 'returnsPlus']; // To keep the order of the environments
    if (this.state.showTrackingV2) {
      envKeys.push('trackingV2');
    }

    if (metadata.isFetching) {
      return <Spin indicator={antIcon} />;
    }

    return (
      <>
        <Row>
          {metadata.developer && userAccessType !== 'restricted' && (
            <Col span={16} offset={4} className="margin-bottom-10">
              <Button
                onClick={() => this.onUpdate()}
                className="ant-btn"
                loading={!!featureEnvs.submitting && this.state.isUpdate}
              >
                {this.state.isUpdate ? 'Save' : 'Edit'}
              </Button>
            </Col>
          )}

          <Col span={16} offset={4}>
            <Card title="Enterprise Login">
              <Row className="margin-bottom-10">
                <Col span={userAccessType === 'restricted' ? 24 : 8}>
                  <Select
                    showSearch
                    style={{
                      width: userAccessType === 'restricted' ? '100%' : '96%'
                    }}
                    placeholder="Select enterprise"
                    optionFilterProp="children"
                    value={
                      this.state.enterpriseId
                        ? this.state.enterpriseId
                        : undefined
                    }
                    onChange={value => this.handleChange('enterpriseId', value)}
                    allowClear={true}
                  >
                    {metadata.enterprise.list.map((enterprise, i) => (
                      <Option key={i} value={enterprise.id}>
                        {enterprise.name}
                      </Option>
                    ))}
                  </Select>
                </Col>
                {userAccessType !== 'restricted' && (
                  <Col span={11}>
                    <Select
                      showSearch
                      style={{ width: '96%' }}
                      placeholder="Select username [profile type]"
                      optionFilterProp="children"
                      value={
                        this.state.user && this.state.user.name
                          ? `${this.state.user.name} [${this.state.user.profile_type}]`
                          : undefined
                      }
                      onChange={value => this.handleChange('userIndex', value)}
                      allowClear={false}
                    >
                      {users.map((user, i) => (
                        <Option key={i} value={i}>
                          {user.username} [{user.profile_type}]
                        </Option>
                      ))}
                    </Select>
                  </Col>
                )}
                {userAccessType !== 'restricted' && (
                  <Col span={5} className="text-right">
                    <Checkbox
                      className="fs-12"
                      onChange={this.handleCheckboxChange}
                    >
                      <b>Is Localhost</b>
                    </Checkbox>
                  </Col>
                )}
              </Row>
              <Row>
                {userAccessType === 'restricted' && (
                  <Col span={24}>
                    <Card
                      className="margin-top-20"
                      type="inner"
                      title="Read-only enterprise login"
                    >
                      <Row>
                        <Col span={24} className="d-flex flex-wrap gap-4">
                          {RESTRICTED_READONLY_ENVS.map(
                            ({ label, link, route, envKey }) => (
                              <ButtonGroup key={envKey}>
                                <Button
                                  type="primary"
                                  onClick={e =>
                                    this.handleClick(e, link, route, envKey)
                                  }
                                  disabled={
                                    !this.state.enterpriseId ||
                                    (this.state.user && !this.state.user.name)
                                  }
                                >
                                  {label}
                                </Button>
                              </ButtonGroup>
                            )
                          )}
                        </Col>
                      </Row>
                    </Card>
                  </Col>
                )}
                {userAccessType !== 'restricted' &&
                  envKeys.map((key, i) => (
                    <Col span={24} key={i + 1}>
                      <Card
                        className="margin-top-20"
                        type="inner"
                        title={`Login to ${labels[key]}`}
                      >
                        <Row>
                          <Col span={24} className="d-flex flex-wrap gap-4">
                            {environments[key]?.map(
                              ({ label, link, locked, route }, index) => (
                                <ButtonGroup key={index}>
                                  <Button
                                    type={locked ? 'primary' : 'ghost'}
                                    onClick={e =>
                                      this.handleClick(e, link, route, key)
                                    }
                                    disabled={
                                      !this.state.enterpriseId ||
                                      (this.state.user && !this.state.user.name)
                                    }
                                  >
                                    {label}
                                  </Button>
                                  {this.state.isUpdate && !locked && (
                                    <Button
                                      type="ghost"
                                      icon="edit"
                                      title="Edit in Developer Section"
                                      onClick={() =>
                                        this.startEditFeatureEnv(key, index)
                                      }
                                      disabled={
                                        !this.state.enterpriseId ||
                                        (this.state.user &&
                                          !this.state.user.name)
                                      }
                                    />
                                  )}
                                  {this.state.isUpdate && (
                                    <Button
                                      type={locked ? 'primary' : 'ghost'}
                                      onClick={e =>
                                        locked
                                          ? null
                                          : this.onDelete(e, key, index)
                                      }
                                      icon={locked ? 'lock' : 'delete'}
                                      disabled={
                                        !this.state.enterpriseId ||
                                        (this.state.user &&
                                          !this.state.user.name)
                                      }
                                    />
                                  )}
                                </ButtonGroup>
                              )
                            )}
                          </Col>
                        </Row>
                      </Card>
                    </Col>
                  ))}
                {this.state.isUpdate && userAccessType !== 'restricted' && (
                  <Col span={24}>
                    <Card
                      className="margin-top-20"
                      type="inner"
                      title={
                        this.state.editingFeatureEnv
                          ? 'Edit feature environment'
                          : 'Developer Section (add new)'
                      }
                    >
                      <Row>
                        <Col span={24} className="d-flex gap-4 flex-wrap">
                          <Input
                            placeholder="Label"
                            value={this.state.label}
                            onChange={e =>
                              this.handleChange('label', e.target.value)
                            }
                          />
                          <Input
                            placeholder="https://…"
                            value={this.state.link}
                            onChange={e =>
                              this.handleChange('link', e.target.value)
                            }
                          />
                          <Input
                            placeholder="/route/path"
                            value={this.state.route}
                            onChange={e =>
                              this.handleChange('route', e.target.value)
                            }
                          />
                          <Select
                            style={{ minWidth: 160 }}
                            showSearch
                            placeholder="Dashboard type"
                            optionFilterProp="children"
                            value={
                              this.state.type ? this.state.type : undefined
                            }
                            onChange={value => this.handleChange('type', value)}
                            allowClear={true}
                          >
                            {dashboardTypes.map(({ label, value }, i) => (
                              <Option key={i} value={value}>
                                {label}
                              </Option>
                            ))}
                          </Select>
                          <Button
                            type="primary"
                            onClick={this.applyFeatureEnvForm}
                          >
                            {this.state.editingFeatureEnv
                              ? 'Apply changes'
                              : 'Add feature'}
                          </Button>
                          {this.state.editingFeatureEnv && (
                            <Button onClick={this.clearFeatureEnvForm}>
                              Cancel edit
                            </Button>
                          )}
                        </Col>
                      </Row>
                    </Card>
                  </Col>
                )}
                {userAccessType !== 'restricted' && (
                  <Col span={24} className="margin-top-10">
                    <b>Note: </b> Ghost-colored buttons represent feature
                    development environments, while primary-colored buttons
                    signify production/staging. Feature development environments
                    are temporary.
                    {this.state.isUpdate && (
                      <>
                        {' '}
                        <b>Save</b> syncs the server (adds, edits, and
                        removals).
                      </>
                    )}
                  </Col>
                )}
              </Row>
            </Card>
          </Col>
        </Row>
      </>
    );
  }
}

DashboardLogin.propTypes = {
  metadata: PropTypes.object,
  featureEnvs: PropTypes.object,
  config: PropTypes.object,
  match: PropTypes.object,
  fetchActiveReportsMetaData: PropTypes.func,
  fetchEnterpriseByUser: PropTypes.func,
  fetchFeatureEnvs: PropTypes.func,
  updateFeatureEnvs: PropTypes.func,
  submitFeatureEnvs: PropTypes.func,
  dashboardLogin: PropTypes.func
};

DashboardLogin.contextTypes = {
  router: PropTypes.object.isRequired
};

const mapStateToProps = state => ({
  config: state.session.config,
  metadata: state.session.metadata,
  featureEnvs: state.session.featureEnvs
});

const mapDispatchToProps = dispatch => ({
  fetchActiveReportsMetaData: query =>
    dispatch(fetchActiveReportsMetaData(query)),
  fetchEnterpriseByUser: () => dispatch(fetchEnterpriseByUser()),
  fetchFeatureEnvs: () => dispatch(fetchFeatureEnvs()),
  updateFeatureEnvs: data => dispatch(updateFeatureEnvs(data)),
  submitFeatureEnvs: data => dispatch(submitFeatureEnvs(data)),
  dashboardLogin: enterpriseId => dispatch(dashboardLogin(enterpriseId))
});

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(DashboardLogin)
);
